import getApiClient from '@/plugins/api-client'

export default {
  loadMessage () {
    const api = getApiClient(this.$store)

    const id = this.$route.params.id

    api.get(`contact_messages/${id}`)
      .then(result => {
        this.message = result.data
      })
      .catch(error => {
        this.error = error
      })
  },
}
